var agi = agi || {};
agi.expressions = agi.expressions || {};

(function() {
    "use strict";
    // TODO Resolve duplication between
    // this loader and the main product

    var exp = function exp() {};
    exp.originalWidth = 1024;
    exp.originalHeight = 672;

    exp.init = function init() {
        exp.container = document.getElementById(
            expressionProduct.env.expressionContainer);
        exp.loader = document.querySelector("#agi-expression-container .loader");
        exp.scaleContainer();
        exp.createLoader();
        window.addEventListener("resize", exp.scaleContainer);
    };

    exp.createLoader = function createLoader() {
        var productNumber = 3502242;
        var assetPath = imghost + "/product/expressions/" + productNumber;
        var options  = {
            imgPath: assetPath,
        }
        if (exp.loader) {
            var layout = AGI.templates._3502242.preloader(options);
            exp.loader.innerHTML = layout;
            exp.setupAnimation();
        }
    }

    exp.setupAnimation = function setupAnimation() {
        var lastDot = document.getElementById("dot6");
        var onAnimationEnd = function(e) {
            var allDots = document.getElementById("agi-expression-container")
                .getElementsByClassName("dot");
            for (var i = 0; i < allDots.length; i++){
                exp.resetAnimation(allDots[i],"agi-expression-loader-animation");
            }
            setupAnimation();
        }
        lastDot.removeEventListener("animationend", onAnimationEnd);
        lastDot.removeEventListener("webkitAnimationEnd", onAnimationEnd);
        lastDot.addEventListener("animationend", onAnimationEnd);
        lastDot.addEventListener("webkitAnimationEnd", onAnimationEnd);
    }

    exp.resetAnimation = function resetAnimation(node, className) {
        var clone = node.cloneNode(true);
        node.parentNode.replaceChild(clone, node);
        return clone;
    }

    exp.scaleContainer = function scaleContainer(event) {
        //Instead of basing scaling on window width, base it on grand container width
        exp.container.style.width = 1024 + "px";
        exp.container.style.height = 672 + "px";
        var grandParent = exp.container.parentElement;
        var compStyle = getComputedStyle(grandParent);
        var containerSize = parseFloat(compStyle.width);
        var scale = containerSize / exp.originalWidth;

        //Compare scales and go with the lower one
        if ((parseFloat(compStyle.height)/exp.originalHeight) < scale) {
            containerSize = parseFloat(compStyle.height);
            scale = containerSize / exp.originalHeight;
        }

        //Never mind, scale is nice here
        scale = (scale > 1) ? 1 : scale;

        //Change the container width and height by scale
        exp.container.style.width = 1024*scale + "px";
        exp.container.style.height = 672*scale + "px";
        exp.container.style.margin = "0 auto";

        //Only change card div, not the parent controlled by css
        //Force change the width so that we can scale with margins
        exp.loader.style.width = exp.originalWidth*scale;
        exp.loader.style.margin = "0 auto";
        exp.loader.style.transformOrigin = "top left";
        exp.loader.style.webkitTransformOrigin = "top left";
        exp.loader.style.transform = "scale("+scale+","+scale+")";
        exp.loader.style.webkitTransform = "scale("+scale+","+scale+")";
    };

    exp.init();

})();
